module.exports = __webpack_public_path__ + "img/bluelabel2.364f28d7.jpg";